import { SAVE_TOKEN } from '../actions/types';
import { setter } from './utils';

export default setter(SAVE_TOKEN, '');
